<template>
  <div class="w-full mt-12">
    <div class="flex flex-row items-center mb-4">
      <div class="alt-logins-title__text font-light text-md mr-5">{{ t('auth.orContinueWith') }}</div>
      <div class="border-t border-black/30 flex-grow"/>
    </div>
    <div class="flex h-9 gap-3">
      <CustomButton :outlined="true" :rounded="true" class="w-36">
        <img src="@/assets/icons/svg/Facebook_16x16.svg" alt="facebook">
        <span class="alt-logins-btn__text font-semibold">{{ t('auth.facebook') }}</span>
      </CustomButton>
      <CustomButton :outlined="true" :rounded="true" class="w-36">
        <img src="@/assets/icons/svg/Google_16x16.svg" alt="google">
        <span class="alt-logins-btn__text font-semibold">{{ t('auth.google') }}</span>
      </CustomButton>
    </div>
  </div>
</template>

<script setup>
import CustomButton from "@/components/Button/Button.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
</script>

<style scoped>

@media (max-width: 1538px) {
  .alt-logins-title__text {
    font-size: .875rem
  }
  .alt-logins-btn__text {
    font-size: .875rem;
  }
}
@media (max-width: 1024px) {

}
@media (max-width: 768px) {
  .alt-logins-title__text {
    font-size: .6875rem
  }
}
</style>